// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RUAI","name":"styles_name__hiY5g","phone":"styles_phone__27Loa"};